import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const FollowupEmailConfig = {
	name: NAME,
	apiProvider,
	router,
};
